import moment from 'moment'
import {rupiah} from 'utils/formatter'
import styles from './style.css'

class PurchaseHistory extends React.Component {
  render () {
    let {customerDetail} = this.props

    return (customerDetail &&
      <div className='customer-info-box'>
        <div className='header2'>
          Purchase History
        </div>
        <table className='table mk-table-fixed mk-table-clickable moka-table-details' id='purchase-history-table'>
          <thead>
            <tr>
              <th>
                Date
              </th>
              <th>
                Outlet
              </th>
              <th className='text-right'>
                Sale
              </th>
            </tr>
          </thead>
          <tbody>
            {(customerDetail.payments.length > 0) &&
            customerDetail.payments.map((payment, idx) => {
              return (
                <tr key={idx} onClick={() => this._onClickRowHistory(payment)}>
                  <td>
                    {moment(payment.created_at).format('DD/MM/YYYY')}
                  </td>
                  <td className={styles['col-outlet']}>
                    {payment.outlet_name}
                  </td>
                  <td className={'text-right ' + styles['col-sale']}>
                    {this._purchaseHistoryTotalFormatter(payment)}
                  </td>
                </tr>
              )
            })
          }
          </tbody>
        </table>
      </div>
    )
  }

  _purchaseHistoryTotalFormatter = (payment) => {
    let amount = payment.is_refunded
      ? rupiah(parseFloat(payment.refund_amount).toFixed(0))
      : rupiah(parseFloat(payment.total_collected).toFixed(0))

    if (payment.is_refunded) {
      amount = '(' + amount + ')'
    }

    return amount
  }

  _onClickRowHistory = (payment) => {
    this.props.onClickHistory(payment)
  }
}

PurchaseHistory.propTypes = {
  customerDetail: React.PropTypes.object,
  onClickHistory: React.PropTypes.func
}

export default PurchaseHistory



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListNonLoyalty/CustomerDetail/PurchaseHistory.js